import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Suppress ResizeObserver loop warning in all environments (error and warn)
const suppressedWarnings = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded'
];
const originalError = console.error;
const originalWarn = console.warn;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    suppressedWarnings.some(warning => args[0].includes(warning))
  ) {
    return;
  }
  originalError(...args);
};
console.warn = (...args) => {
  if (
    typeof args[0] === 'string' &&
    suppressedWarnings.some(warning => args[0].includes(warning))
  ) {
    return;
  }
  originalWarn(...args);
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
